document.addEventListener("DOMContentLoaded", function () {
  const bookBtn = document.getElementById("book-test-ride-btn");
  const modal = document.getElementById("product-booking-modal");
  const closeBtn = modal?.querySelector(".close-modal");

  const step2 = document.getElementById("step2-product-modal");
  const stepHome = document.getElementById("step-home");
  const stepInStore = document.getElementById("step-in-store");

  if (bookBtn && modal) {
    bookBtn.addEventListener("click", (e) => {
      e.preventDefault();
      modal.classList.remove("hidden");
      modal.classList.add("active");

      window.selectedModel = {
        handle: e.target.dataset.productHandle,
        title: e.target.dataset.productTitle
      };

      // Reiniciar pasos visibles
      step2.style.display = "block";
      stepHome.style.display = "none";
      stepInStore.style.display = "none";
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      modal.classList.add("hidden");
      modal.classList.remove("active");
    });
  }

  const btnHome = document.getElementById("product-test-at-home");
  const btnShowroom = document.getElementById("product-test-in-showroom");

  if (btnHome && btnShowroom) {
    btnHome.addEventListener("click", () => {
      btnHome.classList.add("selected");
      btnShowroom.classList.remove("selected");

      step2.style.display = "none";
      stepHome.style.display = "block";
      stepInStore.style.display = "none";

      window.testRideType = "home";
    });

    btnShowroom.addEventListener("click", () => {
      btnShowroom.classList.add("selected");
      btnHome.classList.remove("selected");

      step2.style.display = "none";
      stepHome.style.display = "none";
      stepInStore.style.display = "block";

      window.testRideType = "showroom";
    });
  }
});

